import React, { useState, useEffect } from 'react';
import Axios from 'axios';
import { useParams } from 'react-router-dom';

import ProgressIndicator from '../../Common/ProgressIndicator';
import ErrorIndicator from '../../Common/ErrorIndicator';
import UserEditForm from './UserEditForm';

function UserEditPage(props) {
    const [isLoading, setIsLoading] = useState(false);
    const [isMembersLoading, setIsMembersLoading] = useState(false);
    const [error, setError] = useState(false);
    const [user, setUser] = useState(null);
    const [members, setMembers] = useState([]);
    const { id } = useParams();

    useEffect(() => {
        setIsLoading(true);
        Axios.get(`/admin/users/${id}`).then(res => {
            setUser(res);
            setIsLoading(false);
        }, err => {
            setIsLoading(false);
            setError(true);
        });
        Axios.get('/users/firma').then(res => {
            setMembers(res);
            setIsMembersLoading(false);
        }, err => {
            setError(true);
            setIsMembersLoading(false);
        });
    }, [id]);

    if (isLoading || isMembersLoading)
        return <ProgressIndicator />;

    if (error)
        return <ErrorIndicator text="A felhasználó letöltése sikertelen." />;

    if (user)
        return (
            <>
                <h1>Felhasználó szerkesztése</h1>
                <UserEditForm user={user} members={members} />
            </>
        );

    return null;
}

export default UserEditPage;
